import { useNavigate, useParams } from "react-router-dom";
import useCurrentUserProfile from "../../../hooks/useCurrentUserProfile";
const UniversityDeanDashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const {profile} = useCurrentUserProfile()
  // console.log("The profile is:",profile)
  return (
    <div className="p-6">
  <div className="mx-auto bg-blue-50 border border-blue-200 rounded-xl p-5 shadow-sm">
    
    <h2 className="text-lg font-semibold text-blue-900 mb-2">
      {profile?.name}
    </h2>

    <p className="text-sm text-blue-800">
      You are the Dean of{" "}
      <span className="font-medium">{id}</span>. 
      To view your associated departments, please navigate to the{" "}
      <span className="font-medium">Departments</span> tab or click below.
    </p>

    <button
      onClick={() => navigate(`/marketplace/${id}/dean/departments`)}
      className="mt-4 px-12 py-3 bg-[#0f6abf] text-white text-sm rounded-lg hover:bg-[#0a5ca8] transition"
    >
      Go to Departments
    </button>

    {/* Permission Message */}
 {/* Permission Section */}
<div className="mt-4 p-4 bg-white border border-blue-100 rounded-lg">
  <p className="text-sm font-semibold text-gray-800 mb-2">
    You have permissions to:
  </p>

  <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
    <li>
      Add Labs (including all related child operations under each lab)
    </li>

    <li>
      Assign Lab Heads (and manage all operations related to lab heads, including their associated child entities and responsibilities)
    </li>
  </ol>
</div>

  </div>
</div>
  );
};

export default UniversityDeanDashboard;
